import React, {PureComponent} from 'react';
import {injectIntl} from 'react-intl';
import Icon from "../common/icon/Icon";
import SAModal from "../common/modal/SAModal";

class MoreInfo extends PureComponent {


    constructor(props){
        super(props);
        this.state = {
            moreInfoVisible: false
        }
    }

    handleMoreInfo = () => {
        const {moreInfoVisible} = this.state;
        this.setState({moreInfoVisible:!moreInfoVisible});
    };

    render() {
        const {text} = this.props;

        return (
            <React.Fragment>
                    <Icon className="bmw-icon" name="icon-info" onClick={evt=>{evt.stopPropagation();this.handleMoreInfo()}}/>
                    {this.props.children}
                <SAModal
                  visible={this.state.moreInfoVisible}
                  closable={true}
                  onCancel={()=>this.setState({moreInfoVisible:false})}
                  footer={null}>
                    <div dangerouslySetInnerHTML={{__html: text}}/>
                </SAModal>
            </React.Fragment>
        );
    }
}


export default injectIntl(MoreInfo);



// WEBPACK FOOTER //
// ./src/components/consent/MoreInfo.js